<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-users'"></top-line>
    <el-row class="page-body">
      <el-row class="filter-bar">
        <el-card shadow="never">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="200px" size="small">
            <el-row >
              <el-col :span="20">

                <el-form-item label="合同名称：" prop="order_no" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.order_no" style="width:175px" />
                </el-form-item>
                <el-form-item label="客户名称:" prop="customer_name" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.customer_name" style="width:175px" />
                </el-form-item>
                <el-form-item label="账单状态:" prop="status" class="search-item" :label-width="labelWidth">
                  <el-select v-model="searchForm.status" placeholder="请选择状态">
                    <el-option label="待确认" value="1"></el-option>
                    <el-option label="已确认" value="2"></el-option>
                    <el-option label="已作废" value="3"></el-option>

                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" icon="el-icon-search" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleSearch">
                  查询
                </el-button>
                <el-button type="info" icon="el-icon-refresh-left" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleReset">
                  重置
                </el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-row>
      <el-row class="main-table">
          <el-table
            :data="tableData"
            border
            stripe
            style="width: 100%">
            <!-- <el-table-column fixed prop="id" label="ID" width="130px"  show-overflow-tooltip/> -->
            <el-table-column fixed prop="id" label="ID" width="290px"  show-overflow-tooltip>
              <template v-slot="scope">
                <el-button type="text" size="small" @click="billShowDetails(scope.row)" class="id-column">
                {{ scope.row.id }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column  prop="customer_name" label="客户名称" width="180" show-overflow-tooltip />
            <el-table-column prop="order_no" label="合同名称" width="220px"  show-overflow-tooltip/>
            <el-table-column prop="status" label="账单状态" width="100" align="center">
              <template v-slot="scope">
                 <el-tag :type="getTagTypeFormat(scope.row.status)">
                  {{ formatStatus(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="bill_month" label="账单月份" width="130px" align="center" />
            <el-table-column prop="total_amount" label="账单金额(元)" width="180px" align="right" :formatter="formatAmount" />
            <el-table-column prop="resolved_at" label="创建时间" width="170px">
              <template #default="{ row }">
                {{ formatDateTime(row.created_at) }}
              </template>
            </el-table-column>
            <el-table-column  header-align="left" align="left" show-overflow-tooltip  label="操作">
              <template v-slot="scope">
                  <el-button
                  type="text"
                  size="mini"
                  @click="billShowDetails(scope.row)">账单明细</el-button>
              </template>
            </el-table-column>
        </el-table>
      </el-row>
      <el-row type="flex" justify="left" style="margin-top: 10px; margin-bottom: 18px;">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.page"
            :page-sizes="pagination.pageSizeList"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
      </el-row>
    </el-row>

    <!-- 新增组件 -->
    <create-provider ref="createProvider" @success="getTableData"></create-provider>
     <!-- 编辑组件 -->
    <edit-provider ref="editProvider" @success="getTableData"></edit-provider>
  </d2-container>

</template>
<script>
import CreateProvider from './CreateBill.vue'; //
import EditProvider from './EditBill.vue'; // 引入编辑组件
import topLine from "@/components/save-common/topLine.vue";
import commonListMixin from "@/pages/mixin/mixin-common-list";
import util from '@/libs/util.js'
import { MessageBox } from 'element-ui';

export default {
  name: "allns",
  // mixins: [
  //   commonListMixin
  // ],
  components: {
    topLine,
    CreateProvider,
    EditProvider, // 注册组件
  },
  mounted () {
    this.loadParams();
  },
  data() {
    return {
      pageTitle: "账单列表",
      labelWidth: '120px',
      tableDataApi: '/api-30216/api/bills',
      searchForm: {
        order_no: '',
        customer_name: '',
        status:'',
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
      },
      pagination: {
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
        total: 0,
      },
      tableData: []
    }
  },
  methods: {

    formatAmount(row, column, cellValue) {
      // 处理 null/undefined
      if (cellValue == null || isNaN(cellValue)) return '0.00';

      // 转为数字，保留两位小数，千分位逗号
      const num = parseFloat(cellValue).toFixed(2);
      return Number(num).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    getTagTypeFormat(value) {
      switch (value) {
        case 1:
          return ;     // '有效' → 绿色
        case 2:
          return 'success';  // '关闭' → 红色
        case 3:
          return 'danger';  // '待定' → 灰色
        default:
          return 'info';
      }
    },
    // 格式化状态
    formatStatus(value) {
      const map = {
        1: '待确认',
        2: '已确认',
        3: '已作废'
      };
      return map[value] || '-';
    },
    formatDateTime(datetime) {
      if (!datetime) return '';
      const date = new Date(datetime);
      const Y = date.getFullYear() + '-';
      const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      const D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      const h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      const m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },

    loadParams() {
      if(this.$route.query.page) {
        this.pagination.page = parseInt(this.$route.query.page, 10);
      }
      if(this.$route.query.pageSize) {
        this.pagination.pageSize = parseInt(this.$route.query.pageSize, 10);
      }
      // 根据新的分页参数重新加载数据
      this.getTableData();
    },
    handleReset() {
      this.searchForm = {
        order_no: '',
        customer_name: '',
        status:'',
        page: 1,
        pageSize: 10,
      };
      this.getTableData();
    },
    //查询
    handleSearch() {
      this.pagination.page = 1;
      this.getTableData();
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.getTableData();
    },
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.getTableData();
    },

    getTableData() {
      this.$axios.get(this.tableDataApi, {
       params: {
        order_no: this.searchForm.order_no,
        customer_name: this.searchForm.customer_name,
        status: this.searchForm.status,
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
      }
      }).then(response => {
        console.log(response);
        this.tableData = response.data || [];
        this.pagination.total = response.total || 0;
      });
    },

    // 跳转账单明细
    billShowDetails(row) {
      // console.log(row.id)
      this.$router.push({
        path: '/billShowDetails',
        query: {
          id: row.id,
          page: this.pagination.page,       // 当前页码
          pageSize: this.pagination.pageSize, // 页面大小
        }
      })
    },



  }
}
</script>

<style scoped lang="scss">
.page-body {
  margin-top: 20px;
  margin-left: 20px;
}
.filter-bar {
  margin-bottom: 10px;
}
.main-table {
  margin-top: 10px;
}
.id-column {
  font-family: consolas,serif;
}

.search-button-line {
  display: flex;
  justify-content: flex-end;
}
.batch-button {
  min-width: 95px;
}
</style>
